import {appURL, getLoginRequest, getMsalConfig} from "./authConfig";
import {InteractionType, PublicClientApplication} from "@azure/msal-browser";
import {
    AuthCodeMSALBrowserAuthenticationProvider
} from "@microsoft/microsoft-graph-client/authProviders/authCodeMsalBrowser";
import storageHelper from "./core/storageHelper";
import {clientManagementApiClient} from "./ClientManagement/ClientManagementApiClient";
import * as jwtDecode from "jwt-decode";

let sharedMsalInstance: PublicClientApplication;
export const initializeMsalInstance = () => {
    if (!sharedMsalInstance) sharedMsalInstance = new PublicClientApplication(getMsalConfig());
    return sharedMsalInstance;
}

const getActiveAccountName = () => {
    return initializeMsalInstance().getAllAccounts()[0].name
}

export function handleLogin(msal: any) {
    msal.instance.loginRedirect(getLoginRequest()).then(() => {
            acquireToken(msal);
        }
    ).catch((e: any) => {
        console.error(e);
    });

}

async function sessionTokenManagement(msal: any) {
    try {
        const accessToken = await acquireToken(msal);
        await clientManagementApiClient.postSessionManagement(accessToken);
    } catch (e) {
        console.error("Failed to notify server for logout", e);
    }
}

export async function handleLogout(msal: any) {
    await sessionTokenManagement(msal);

    let activeAccount = msal.instance.getActiveAccount();
    if (!activeAccount) {
        const allAccounts = msal.instance.getAllAccounts();
        if (allAccounts && allAccounts.length > 0) {
            msal.instance.setActiveAccount(allAccounts[0]);
            activeAccount = allAccounts[0];
        }
    }

    const logoutRequest = {
        account: activeAccount,
        postLogoutRedirectUri: appURL,
    };

    msal.instance.logoutRedirect(logoutRequest).catch((e: any) => {
        console.error(e);
    });
}

export const acquireToken = (msal?: any) => {
    const msalInstance = msal ? msal.instance : sharedMsalInstance;
    const request = {
        scopes: getGPIReadScope(),
        forceRefresh: false,
        account: msal ? msal.accounts[0] : sharedMsalInstance?.getAllAccounts()[0]
    };

    return msalInstance?.acquireTokenSilent(request)
        .then((response: { accessToken: string }) => response.accessToken)
}

function getGPIReadScope(): Array<string> {
    return storageHelper.getSpaConfigBase().scopes.split(" ").filter(s => s.includes("GPI.Read"))
}

export const acquireAADTokenForTeamsUser = (msal?: any) => {
    const msalInstance = msal ? msal.instance : sharedMsalInstance;
    const request = {
        ...getLoginRequest(),
        scopes:
            [
                "https://auth.msft.communication.azure.com/Teams.ManageCalls",
                "https://auth.msft.communication.azure.com/Teams.ManageChats"
            ],
        account: msal ? msal.accounts[0] : sharedMsalInstance?.getAllAccounts()[0]
    };

    return msalInstance?.acquireTokenSilent(request)
        .then((response: { accessToken: string }) => response.accessToken);
}

export const getAuthProvider = (msal: any) => {
    return new AuthCodeMSALBrowserAuthenticationProvider(sharedMsalInstance, {
        account: msal.accounts[0],
        interactionType: InteractionType.Silent,
        scopes: ["OnlineMeetings.ReadWrite"]
    });
}

export const getAccountName = (msal: any) => {
    return msal.accounts[0].name
}

export const getLanId = (msal: any) => {
    if (!msal || !msal.accounts || msal.accounts.length === 0 || !msal.accounts[0].username) {
        return "";
    }
    return msal.accounts[0].username.split('@')[0];
}

export const getOid = (msal: any) => {
    if (!msal || !msal.accounts || msal.accounts.length === 0 || !msal.accounts[0].idTokenClaims || !msal.accounts[0].idTokenClaims.oid) {
        return "";
    }
    return msal.accounts[0].idTokenClaims.oid;
}

export const getAccountEmail = (msal: any) => {
    if (!msal || !msal.accounts || msal.accounts.length === 0 || !msal.accounts[0].idTokenClaims || !msal.accounts[0].idTokenClaims.emailAddress) {
        return "";
    }
    return msal.accounts[0].idTokenClaims.emailAddress;
}

export const getAccountPhoneNumber = (msal: any) => {
    if (!msal || !msal.accounts || msal.accounts.length === 0 || !msal.accounts[0].idTokenClaims || !msal.accounts[0].idTokenClaims.workPhone) {
        return "";
    }
    return msal.accounts[0].idTokenClaims.workPhone;
}

export const getAccountTitle = (msal: any) => {
    if (!msal || !msal.accounts || msal.accounts.length === 0 || !msal.accounts[0].idTokenClaims || !msal.accounts[0].idTokenClaims.title) {
        return "";
    }
    return msal.accounts[0].idTokenClaims.title;
}

export const getAccountUserObjectId = (msal: any) => {
    if (!msal || !msal.accounts || msal.accounts.length === 0 || !msal.accounts[0].localAccountId) {
        return "";
    }
    return msal.accounts[0].localAccountId;
}

export function getGroupsFromToken(token: string): string[] | undefined {
    try {
        const decoded: any = jwtDecode.jwtDecode(token);
        return decoded.groups;
    } catch (e) {
        console.error("Failed to decode token for groups", e);
        return undefined;
    }
}

export const msalBrowserUtils = {
    getActiveAccountName: getActiveAccountName,
}

export const msalUtils = {
    handleLogin: handleLogin,
    handleLogout: handleLogout,
    acquireToken: acquireToken,
    acquireAADTokenForTeamsUser: acquireAADTokenForTeamsUser,
    getAccountName: getAccountName,
    getLanId: getLanId,
    getAccountEmail: getAccountEmail,
    getAccountPhoneNumber: getAccountPhoneNumber,
    getAccountTitle: getAccountTitle,
    getAccountUserObjectId: getAccountUserObjectId,
    getAuthProvider: getAuthProvider,
    getOid: getOid,
    getGroupsFromToken: getGroupsFromToken
};
